module.exports = {"210503001":"河东街道","210503003":"河西街道","210503005":"彩屯街道","210503006":"竖井街道","210503007":"彩北街道","210503009":"东风街道","210503010":"石桥子街道","210503011":"日月岛街道","210503012":"张其寨街道","210503013":"火连寨街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210503.json
// module id = 492
// module chunks = 0